import { InputHTMLAttributes, useRef } from "react";
import notify from "@common/helpers/NotificationManager";
import { __ } from "@common/helpers/i18n";
import { icon } from "@common/helpers/icons";
import { TextInputProps } from "@common/types";
import { IconButton } from "./Button";
import { TextInput } from "./TextInput";

export function CopyInput(
  props: InputHTMLAttributes<HTMLInputElement> & TextInputProps,
) {
  const ref = useRef<HTMLInputElement>(null);

  return (
    <TextInput
      ref={ref}
      {...props}
      onClick={(e) => {
        e.currentTarget.select();
        props.onClick?.(e);
      }}
      icon={
        <IconButton
          type="button"
          className="text-primary-500"
          onClick={() => {
            if (!ref.current) return;
            ref.current.select();
            document.execCommand("copy");
            notify.success(__("Text copied!"));
          }}
          icon={icon("copy")}
          aria-label={__("Copy")}
        />
      }
      iconPosition="end"
    />
  );
}
